import { render, staticRenderFns } from "./MiniNotificacionSocial.vue?vue&type=template&id=6c32c537&"
import script from "./MiniNotificacionSocial.vue?vue&type=script&lang=js&"
export * from "./MiniNotificacionSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports